module.exports = __webpack_public_path__ + "static/media/girlcar.11e2224b.jpg";